"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2857],{

/***/ 772857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _components_PromoList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(151675);



var PromoList4 = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PromoList__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            cardNumer: 4
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PromoList4);


/***/ })

}]);